import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export function LoadingOverlay() {
  return (
    <Box sx={{
        display: "flex",
        position: "fixed",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        justifyContent: "center",
        alignItems: "center",
    }}>
      <CircularProgress size={100}/>
    </Box>
  );
}